import Button from "@mui/material/Button";
import styled from "styled-components";

const mainColor = "#fd6520";
const textColor = "#333333";
const secondaryTextColor = "#666666";
const titleColor = "#0b234c";

export const ClinicCard = styled.article`
  && {
    height: 100%;
    min-height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    overflow: hidden;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
  }

  &&:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.16);
  }
`;

export const ClinicCardContent = styled.div`
  && {
    flex: 1;
    padding: 16px;
  }
`;

export const ClinicCardName = styled.h3`
  && {
    margin: 0 0 12px;

    font-family: Figtree, sans-serif;
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;

    color: ${titleColor};
  }
`;

export const ClinicCardAddress = styled.p`
  && {
    margin: 0 0 8px;

    font-family: Figtree, sans-serif;
    font-size: 14px;
    line-height: 20px;

    color: ${secondaryTextColor};
  }
`;

export const ClinicCardContactInfo = styled.p`
  && {
    margin: 0 0 6px;

    font-family: Figtree, sans-serif;
    font-size: 14px;
    line-height: 20px;

    color: ${textColor};
  }

  &&:last-child {
    margin-bottom: 0;
  }
`;

export const ClinicMapsButton = styled(Button)`
  && {
    width: 100%;
    border-radius: 0;
    padding: 10px 16px;

    background-color: ${mainColor};

    font-family: Figtree, sans-serif;
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;

    color: #ffffff;
  }

  &&:hover {
    background-color: #e85a18;
  }

  &&:focus-visible {
    outline: 2px solid #0b234c;
    outline-offset: 2px;
  }
`;